import { observable } from "mobx";
import { Type } from "class-transformer";
import AccountingDocumentCandidateApprovalType from "./accountingDocumentCandidateApprovalType";
import DateRangeRequest from "./dateRangeRequest";
import DecimalRangeRequest from "./decimalRangeRequest";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentCandidateSearchRequest {
  /**
   * Number of records to be selected.
   * @example
   * 20
   */
  @observable
  limit?: number;

  @observable
  offset?: number;

  @observable
  @Type(() => DateRangeRequest)
  accountingDate?: DateRangeRequest;

  @observable
  accountingPeriod?: string;

  @observable
  sequenceName?: string;

  @observable
  @Type(() => DecimalRangeRequest)
  creditSum?: DecimalRangeRequest;

  @observable
  @Type(() => DecimalRangeRequest)
  debitSum?: DecimalRangeRequest;

  @observable
  approvedBy?: AccountingDocumentCandidateApprovalType;

  @observable
  notApprovedBy?: AccountingDocumentCandidateApprovalType;

  @observable
  accountingTemplateId?: string;
}

export const AccountingDocumentCandidateSearchRequestValidationRules: EntityValidationRules<AccountingDocumentCandidateSearchRequest> =
  {
    sequenceName: {
      isLength: { max: 10 },
    },
  };
